import React from 'react';

const ModalContent = ({ mediaObj }) => {
  const isScreenshot = mediaObj.type === 'SCREENSHOT';
  const isYoutube =
    ['VIDEO', 'PITCH'].includes(mediaObj.type) &&
    mediaObj.subType === 'YOUTUBE';
  const isVimeo =
    ['VIDEO', 'PITCH'].includes(mediaObj.type) && mediaObj.subType === 'VIMEO';
  const isDocument = mediaObj.type === 'DOCUMENT';

  return (
    <div className="w-full h-full flex justify-center items-center">
      {isScreenshot && (
        <img
          src={mediaObj?.urlLarge}
          alt={mediaObj?.alt}
          className="max-h-full max-w-full object-contain"
          loading="lazy"
        />
      )}
      {isYoutube && (
        <div
          className="relative w-full h-0"
          style={{ paddingBottom: '56.25%' }}
        >
          <iframe
            title="Youtube player"
            src={`https://youtube.com/embed/${mediaObj.videoId}?autoplay=0`}
            className="absolute top-0 left-0 w-full h-full"
            allowFullScreen
          />
        </div>
      )}
      {isVimeo && (
        <iframe
          title="Vimeo player"
          src={`https://player.vimeo.com/video/${mediaObj.videoId}`}
          className="w-full h-full"
          allowFullScreen
        />
      )}
      {isDocument && (
        <object
          type="application/pdf"
          data={mediaObj.url}
          width="800"
          height="500"
          aria-label={mediaObj.url}
          className="w-full h-full"
        />
      )}
    </div>
  );
};

export default ModalContent;
